import { render } from "./BtnAnswerCheck.vue?vue&type=template&id=a77515d4&scoped=true"
import script from "./BtnAnswerCheck.vue?vue&type=script&lang=js"
export * from "./BtnAnswerCheck.vue?vue&type=script&lang=js"

import "@/css/components/btn-answer-check.css?vue&type=style&index=0&id=a77515d4&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a77515d4"]])

export default __exports__